module.exports = __webpack_public_path__ + "static/media/boat.74173c8b.png";